import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const LinkWrapper = styled.div`
  a {
    text-decoration: none;
    color: inherit;

    &:focus,
    &:hover,
    &:visited,
    &:link,
    &:active {
      text-decoration: none;
    }
  }
`
const UnstyledLink = ({ children, to, target, rel, external }) => (
  <LinkWrapper>
    {external ? (
      <a rel={rel} target={target} href={to}>
        {children}
      </a>
    ) : (
      <Link to={to}>{children}</Link>
    )}
  </LinkWrapper>
)

UnstyledLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  target: PropTypes.string,
  rel: PropTypes.string,
  external: PropTypes.bool,
}

UnstyledLink.defaultProps = {
  target: null,
  rel: null,
  external: false,
}

export default UnstyledLink
